<template>
	<div class="fuel container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>PROPERTY MANAGEMENT</h4>
			</div>

			<div class="col-md-12">
				<div class="row" v-if="false">
					<div class="col-md-12 mb-3">
						<el-card shadow="hover">
							<h5 class="m-0"><i class="fa fa-bar-chart" aria-hidden="true"></i>&nbsp;&nbsp;PROPERTY MANAGEMENT IFCA</h5>
						</el-card>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">INVOICE VALUE BY REGION</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.invoice" :data="chartdataifcainvoice" :width="500" :height="350"/>
							</div>
						</el-card>
					</div>

					<div class="col-md-4 mb-4" v-if="false">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">TOTAL CONTRACT PRICE BY REGION</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.ifca" :data="chartdataifcacontractprice" :width="500" :height="350"/>
							</div>
						</el-card>
					</div>

					<div class="col-md-4 mb-4" v-if="false">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">EXPIRED CONTRACT ALERT BY REGION</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.ifca" :data="chartdataifcacontractalert" :width="500" :height="350"/>
							</div>
						</el-card>
					</div>

					<div class="col-md-4 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">TOTAL TENANT BY REGION</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.tenant" :data="chartdataifcatotalcontract" :width="500" :height="350"/>
							</div>
						</el-card>
					</div>

                    <div class="col-md-4 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">TOTAL TENANT BY MITRA CATEGORY</h6>
							</div>
							<div>
                                <div class="mb-2">
                                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                                        <el-form-item label="Region">
                                            <el-select v-model="regionbymitracategory" placeholder="Select Region" size="small" style="display: inline-block; width: auto;">
                                                <el-option v-for="(item, idx) in options.region" :key="idx + '_' + item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-form>
                                </div>
								<PieChart v-loading.body="loading.mitra" :data="this.chartdatabymitracategory" :url="''" style="width:100%;"/>
							</div>
						</el-card>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12 mb-4">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">EXPIRED CONTRACT ALERT</h6>
							</div>
							<div>
								<div class="table-nfr-container">
									<table class="table-nfr">
										<thead class="top-header-1">
											<tr>
												<th>No</th>
												<th>Station Id</th>
												<th>Station Name</th>
												<th>Mitra</th>
                                                <th>Region</th>
												<th>Akhir Sewa</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item,idx) in contractalertlist" :key="idx+'_'+item.StationId">
												<td class="text-center">{{ ++idx }}</td>
												<td>{{ item.StationId }}</td>
                                                <td>{{ item.StationName }}</td>
                                                <td>{{ item.MitraName }}</td>
                                                <td class="text-center">{{ item.Region }}</td>
												<td class="text-center">{{ formatDate(item.AkhirKerjasama,'YYYY-MM-DDTHH:mm:ss','dd MMM yyyy') }}</td>
											</tr>
										</tbody>
									</table>
									<Loader v-if="loading.contractalert"/>
								</div>
							</div>
						</el-card>
					</div>
					<div class="col-md-6 mb-4" v-if="false">
						<el-card shadow="hover">
							<div slot="header" class="clearfix">
								<h6 class="text-center m-0">TOTAL CONTRACT PRICE BY REGION</h6>
							</div>
							<div>
								<BarChart v-loading.body="loading.ifca" :data="chartdataifcacontractprice" :width="500" :height="350"/>
							</div>
						</el-card>
					</div>
				</div>

				<div class="row" v-if="false">
					<div class="col-md-12 mb-3">
						<el-card shadow="hover">
							<h5 class="m-0"><i class="fa fa-pie-chart" aria-hidden="true"></i>&nbsp;&nbsp;PROPERTY MANAGEMENT BY STATUS</h5>
						</el-card>
					</div>
				</div>

				<div class="row" v-if="false">
					<div class="col-md-3 mb-4" v-for="(item, idx) in options.region" :key="idx">
						<PiechartCardview :title="item.label" :data="[]" :region="item.value"/>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import { Rainbow, FuelColor, AppColors, AxiosWithJar, Config} from '@/utility.js'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
//import PieChart from '@/components/chart/Pie.js'
import PieChart from '@/components/chart/Doughnut.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

import PiechartCardview from '@/views/pages/PropertyManagement/Component/PiechartCardview.vue'

export default{
	extends: Fuel,
	components:{
		//ListItem,
		//ListCompare, //
		//BarCard,
		PieChart,
		BarChart,
		PiechartCardview,
		Footer,
		Loader
	},
	data() {
		return {
            reportdata: {},
            value: 0,
			chartdataifcainvoice: [],
			chartdataifcacontractalert: [],
			chartdataifcatotalcontract: [],
			chartdataifcacontractprice: [],
			contractalertlist: [],
            chartdatabymitracategory: [],
			stacked: false,
            region: '',
            regionbymitracategory: '',
			loading: {
				ifca: false,
				invoice: false,
				tenant: false,
				mitra: false,
				contractalert: false,
			},
			options: {
				region:[
					{ value: "", name: "", label: "ALL" },
					//{ value: "region", name: "BY REGION", field: "RegionPertareId" },
					{ value: "1", name: "1", label: "REGION 1"  },
					{ value: "2", name: "2", label: "REGION 2"  },
					{ value: "3", name: "3", label: "REGION 3"  },
					{ value: "4", name: "4", label: "REGION 4"  },
					{ value: "5", name: "5", label: "REGION 5"  },
					{ value: "6", name: "6", label: "REGION 6"  },
					{ value: "7", name: "7", label: "REGION 7"  },
				],
			},
            isChildRoute: false,

		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        },
        regionbymitracategory() {
            this.getOverviewByMitraCategory();
        }
	},
	computed: {

	},

    mounted() {
        this.hideNonChildren();
		//this.getOverviewData();
		this.getOverviewInvoice();
		this.getOverviewTotalTenant();
		this.getOverviewContractAlert();
        this.getOverviewByMitraCategory();
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/property-management';
        },
		async getOverviewData() {
			this.urlRequestParams = Config().apiURL

            this.urlRequestParams += '/v1/nfr/ifcaoverview?'
			this.urlRequestParams += '&region=region'
			//this.urlRequestParams += '&area=area'

            this.loading.ifca = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					this.reportdata = response.data;

                    if(this.reportdata) {
						this.chartdataifcainvoice = this.setBarchart(this.reportdata.data.chart.invoice, "Label", "Region", "TotalInvoice");
						this.chartdataifcacontractalert = this.setBarchart(this.reportdata.data.chart.contract_alert, "Label", "Region", "Cnt");
						this.chartdataifcatotalcontract = this.setBarchart(this.reportdata.data.chart.tenant, "Label", "Region", "TenantCount");
						//this.chartdataifcacontractprice = this.setBarchart(this.reportdata.data.chart.contract_price, "Region", "PriceCategory", "Value");
					}

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.ifca = false;
				})
        },

        async getOverviewInvoice() {
			this.urlRequestParams = Config().apiURL

            this.urlRequestParams += '/v1/nfr/overviewinvoice?'
			this.urlRequestParams += 'region=' + this.region
			//this.urlRequestParams += '&area=area'

            this.loading.invoice = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					let resData = response.data;

                    if(resData) {
						this.chartdataifcainvoice = this.setBarchart(resData.data, "Label", "Region", "TotalPendapatan");
					}

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.invoice = false;
				})
        },

        async getOverviewTotalTenant() {
			this.urlRequestParams = Config().apiURL

            this.urlRequestParams += '/v1/nfr/overviewtotaltenant?'
			this.urlRequestParams += 'region=' + this.region
			//this.urlRequestParams += '&area=area'

            this.loading.tenant = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					let resData = response.data;

                    if(resData) {
						this.chartdataifcatotalcontract = this.setBarchart(resData.data, "Label", "Region", "TotalMitra");
					}

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.tenant = false;
				})
        },

        async getOverviewContractAlert() {
			this.urlRequestParams = Config().apiURL

            this.urlRequestParams += '/v1/nfr/overviewcontractalert?'
			this.urlRequestParams += 'region=' + this.region
			//this.urlRequestParams += '&area=area'

            this.loading.contractalert = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					let resData = response.data;

                    if(resData) {
						this.contractalertlist = resData.data;
					}

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.contractalert = false;
				})
        },

        async getOverviewByMitraCategory() {
			this.urlRequestParams = Config().apiURL

            this.urlRequestParams += '/v1/nfr/overviewmitracategory?'
			this.urlRequestParams += 'region=' + this.regionbymitracategory
			//this.urlRequestParams += '&area=area'

            this.loading.mitra = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					let resData = response.data;

                    if(resData) {
						this.chartdatabymitracategory = this.setPiecharthData(resData.data);
					}

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.mitra = false;
				})
        },

        setPiecharthData(data) {
			let item = data //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Mitra] = AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Mitra,
                    amount: item[row].TotalMitra,
                };

                value.push(main);
                idx++;
            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna);
        },

		setBarchart(data, label, legend, valuecol, prefix = 'REGION ') {
			return this.processBarChart(data, legend, prefix, valuecol, false, label, "", 1, 2, AppColors, false, false, false, this.stacked);
		}
	}
}
</script>

<style>

.table-nfr-container {
  /*max-width: 500px; */
  width: 100%;
  margin: auto;
  margin-top: 0rem;
  overflow-x: auto;
  max-height: 350px !important;
}

.table-nfr {
  font-family: "Open Sans", sans-serif;
  position: relative;
  border-collapse: initial; /**collapse */
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
  border: none;
  border-radius: 0rem;
  /*box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);*/
  white-space: nowrap;
}

.table-nfr thead th {
  /*background: #edf2f7; */ /* $gray-200 */
  padding: 0.45rem 1.5rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid white;
  border-left: 0px solid white;
  border-top: 0px solid white;
  border-bottom: 1px solid #F0F0F0;
  background: white;
}

.top-header-1 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

.top-header-2 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 70;
    z-index: 2;
}

.table-nfr thead th:first-child {
    z-index: 4;
}

.table-nfr th:first-child {
  border-top-left-radius: 0rem;
}

.table-nfr th:last-child {
  border-top-right-radius: 0rem;
}


.table-nfr thead tr {
  color: #2d3748; /* $gray-800 */
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.table-nfr tbody tr:nth-child(odd) td {
  background: #ffffff; /* $white */
}

.table-nfr tbody tr:nth-child(even) td {
  background: #FAFBFC /*#edf2f7*/; /* $gray-200 */
}

.table-nfr tbody tr:hover {
  background-color: #e2e8f0 !important; /**e2e8f0 */
}

.table-nfr tbody tr:hover td {
  background-color: #e2e8f0;
}

.table-nfr tbody td {
  color: #1a202c; /* $gray-900 */
  text-align: left;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.925rem;
  font-weight: normal;
  border:0px solid #F0F0F0;
  border-left:0px solid #F0F0F0;
}

.table-nfr tr:last-child td:first-child {
  border-bottom-left-radius: 0rem;
}

.table-nfr tr:last-child td:last-child {
  border-bottom-right-radius: 0rem;
}

.table-nfr tr > th:first-child,
.table-nfr tr > td:first-child {
  position: sticky;
  left: 0;
}


.table-nfr-container::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
}

.table-nfr-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
}

.table-nfr-container::-webkit-scrollbar-thumb {
  background: #A8A8A8; /* Color of the scrollbar thumb */
  border-radius: 6px; /* Roundness of the scrollbar thumb */
}

.table-nfr-container::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color of the scrollbar thumb when hovered */
}

/* For Firefox */
.table-nfr-container {
  scrollbar-width: thin; /* Sets the width of the scrollbar */
  scrollbar-color: #A8A8A8 #f1f1f1; /* Sets the color of the thumb and track */
}

</style>
